import { FC } from 'react';
import { Tabs } from 'antd';
import { useParams, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useSettings } from '@/store';
import { $fm } from '@/Intl';
import { isType } from '@/utils';

import ExportBtn from './ExportBtn';
import ImportBtn from './ImportBtn';

import './index.less';

type TabItem = {
  title: React.ReactNode | string;
  path: string;
  enable: boolean;
};

const { TabPane } = Tabs;

const tabsMapper: Record<string, TabItem> = {
  phonebook: {
    title: $fm('CONTACT_SET'), // 联系人设置
    path: 'phonebook',
    enable: true,
  },
  background: {
    title: $fm('BG_SET'), // 背景设置
    path: 'background',
    enable: true,
  },
  layout: {
    title: $fm('LAYOUT_SET'), // 布局设置
    path: 'layout',
    enable: true,
  },
  callset: {
    title: $fm('CALL_SET'), // 通话设置
    path: 'callset',
    enable: true,
  },
  screensaver: {
    title: $fm('SCREEN_SAVER_SET'), // 屏保设置
    path: 'screensaver',
    enable: true,
  },
  language: {
    title: $fm('LANG_KEYBOARD_SET'), // 语言和键盘
    path: 'language',
    enable: true,
  },
  taskbar: {
    title: $fm('TASKBAR_SET'), // 任务栏
    path: 'taskbar',
    enable: true,
  },
  fitscreen: {
    title: $fm('AUTOSIZE_SET'), // 屏幕自适应
    path: 'fitscreen',
    enable: true,
  },
};

const getTabs = (settings: ConfigSettings): TabItem[] => {
  let result: TabItem[] = [
    {
      title: $fm('CONFIG_SET'),
      path: 'settings',
      enable: true,
    },
  ];

  let mapperKeys = Object.keys(tabsMapper) as Array<keyof ConfigSettings>;

  mapperKeys.forEach((k) => {
    if (!isType(settings[k], 'undefined')) {
      tabsMapper[k].enable = settings[k] === 1;
      result.push(tabsMapper[k]);
    }
  });

  return result;
};

// 顶部tab和导入导出按钮
const BackendHeader: FC<{
  onChange: Func;
}> = ({ onChange }) => {
  const [settings] = useSettings();
  const history = useHistory();
  const { product, part } = useParams<RouterParams>();
  const tabs = getTabs(settings);

  return (
    <>
      <Tabs
        className='backend-header-tabs'
        activeKey={part.toLowerCase()}
        onChange={(k) => {
          history.push(`/${product}/${k}`);
          onChange?.();
        }}
      >
        {tabs.map((t) => (
          <TabPane tab={t.title} key={t.path} disabled={!t.enable}></TabPane>
        ))}
      </Tabs>
      <div className='backend-header-btns'>
        <ExportBtn />
        &nbsp;&nbsp;
        <ImportBtn />
      </div>
    </>
  );
};

export default observer(BackendHeader);
